import { useEffect } from "react";
import { useLocation } from "react-router";

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is the trigger, so every route change scrolls to the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
